import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { UseMutationProps } from "@lib/types/Api";
import { MessageFormatElement } from "react-intl";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import CoinPriceTextFormat from "@lib/components/MiniComponents/Others/CoinPriceTextFormat";
import { ManualTransaction } from "@lib/types/Transaction";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";

type Props<T> = {
  apiData: T[];
  deleteQuery?: UseMutationProps<T>;
  messages: Record<string, string> | Record<string, MessageFormatElement[]>;
};

const getColumns = <T extends ManualTransaction>(
  props: Props<T>,
): ColumnsType<T> => {
  const { deleteQuery } = props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "common.receivedAmount",
      dataIndex: "amount",
      width: "150px",
      align: "right",
      render: (value, r) => (
        <CoinPriceTextFormat
          amount={value}
          currency={r?.currency}
          showCurrency={r?.currency}
        />
      ),
    },
    {
      title: "common.convertedAmount",
      dataIndex: "convertedAmount",
      width: "200px",
      align: "right",
      render: (value, r) => (
        <CoinPriceTextFormat
          amount={value}
          currency={r?.convertedTo}
          showCurrency={r?.convertedTo}
          showCurrencyImage
        />
      ),
    },
    {
      title: "common.description",
      dataIndex: "description",
    },
    {
      title: "common.createdAt",
      dataIndex: "createdAt",
      width: "150px",
      render: (d) => dayjs(d).format("DD/MM/YYYY HH:mm"),
    },
    {
      title: "common.createdBy",
      dataIndex: "createdBy",
      width: "150px",
    },
    {
      title: "common.actions",
      dataIndex: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "100px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <ActionButton
            type="delete"
            itemName="common.manualTransaction"
            onClick={() => deleteQuery?.mutate(record)}
            noLabel
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};
export default getColumns;
